module.exports = __webpack_public_path__ + "img/dolce-vita.ddf71f64.png";